module.exports = __webpack_public_path__ + "static/img/1-1.66630c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/eng/1-1.png
// module id = R8Nd
// module chunks = 0